const regexes = [
  /akamai/gi, // matches CDN during live playback
  /demdex/gi, //
  /dax/gi, // pageload and heartbeat analytics
];

type ApmTransaction = {
  name: string;
  type: string;
  timestamp: string;
};

type ApmPayload = {
  transactions: Array<ApmTransaction>;
  errors: Array<Error>;
};

export const apmRumFilters = (payload: ApmPayload) => {
  if (payload.transactions) {
    payload.transactions = payload.transactions.filter(transaction => {
      for (let i = 0; i < regexes.length; ++i) {
        if (regexes[i]?.test(transaction.name)) {
          return false;
        }
      }
      return true;
    });
  }
  return payload.transactions.length || payload.errors ? payload : false;
};
